import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { jwtDecode } from "jwt-decode"; // 👈 Add this!
import "./NavBar.css";

const CustomNavbar = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userRole, setUserRole] = useState(null); // 👈 Add this!
  const [newReviewsCount, setNewReviewsCount] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("adminToken");
    if (token) {
      setIsLoggedIn(true);
      try {
        const decoded = jwtDecode(token);
        setUserRole(decoded.role); // 👈 Set the role
      } catch (error) {
        console.error("Invalid token");
      }
    } else {
      setIsLoggedIn(false);
      setUserRole(null);
    }

    const handleStorageChange = () => {
      const updatedToken = localStorage.getItem("adminToken");
      if (updatedToken) {
        setIsLoggedIn(true);
        try {
          const decoded = jwtDecode(updatedToken);
          setUserRole(decoded.role);
        } catch (error) {
          console.error("Invalid token");
        }
      } else {
        setIsLoggedIn(false);
        setUserRole(null);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  useEffect(() => {
    const fetchNewReviews = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/controllers/fetch_review_list.php`
        );
        const reviews = response.data.data || [];
        const newReviews = reviews.filter((review) => review.approved === -1);
        setNewReviewsCount(newReviews.length);
      } catch (error) {
        console.error("Error fetching new reviews:", error.message);
      }
    };

    fetchNewReviews();
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
    setIsDropdownOpen(false);
  }, [location.pathname]);

  const handleLogout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    setUserRole(null);
    navigate("/login");
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
    setIsDropdownOpen(false);
  };

  return (
    <div className="nav-container">
      {isLoggedIn && newReviewsCount > 0 && (
        <div className="new-reviews-notification">
          <Link
            to="/review-list"
            className="new-reviews-link"
            onClick={handleLinkClick}
          >
            {newReviewsCount}{" "}
            {newReviewsCount > 1 ? "nya recensioner" : "ny recension"}
          </Link>
        </div>
      )}

      <nav className="custom-navbar">
        <div className="navbar-container">
          {isLoggedIn && newReviewsCount > 0 && (
            <div className="new-reviews-notification new-reviews-desktop-only">
              <Link
                to="/review-list"
                className="new-reviews-link"
                onClick={handleLinkClick}
              >
                {newReviewsCount}{" "}
                {newReviewsCount > 1 ? "nya recensioner" : "ny recension"}
              </Link>
            </div>
          )}

          <button
            className="navbar-toggle"
            onClick={() => setIsMenuOpen((prev) => !prev)}
            aria-expanded={isMenuOpen}
            aria-label="Toggle navigation"
          >
            ☰
          </button>

          <ul className={`navbar-menu ${isMenuOpen ? "open" : ""}`}>
            <li>
              <Link to="/start" className="nav-link" onClick={handleLinkClick}>
                Hem
              </Link>
            </li>

            {isLoggedIn && (
              <li className="dropdown">
                <span
                  className="nav-link dropdown-toggle"
                  onClick={() => setIsDropdownOpen((prev) => !prev)}
                >
                  Admin
                </span>
                {isDropdownOpen && (
                  <ul className="dropdown-menu">
                    {/* Allow both shopowner and admin to see Reviews */}
                    {(userRole === "admin" || userRole === "shopowner") && (
                      <li>
                        <Link
                          to="/review-list"
                          className="dropdown-item"
                          onClick={handleLinkClick}
                        >
                          Recensioner
                        </Link>
                      </li>
                    )}
                    {/* Only admin sees the rest */}
                    {userRole === "admin" && (
                      <>
                        <li>
                          <Link
                            to="/edit-override-working-hours"
                            className="dropdown-item"
                            onClick={handleLinkClick}
                          >
                            Avvikande öppettider
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/create-review-session"
                            className="dropdown-item"
                            onClick={handleLinkClick}
                          >
                            Skapa recension
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/create-article"
                            className="dropdown-item"
                            onClick={handleLinkClick}
                          >
                            Skapa artikel
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/create-information-segment"
                            className="dropdown-item"
                            onClick={handleLinkClick}
                          >
                            Skapa informationssegment
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/create-treatment"
                            className="dropdown-item"
                            onClick={handleLinkClick}
                          >
                            Skapa behandling
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/edit-treatments"
                            className="dropdown-item"
                            onClick={handleLinkClick}
                          >
                            Redigera behandlingar
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/edit-employees"
                            className="dropdown-item"
                            onClick={handleLinkClick}
                          >
                            Redigera personal
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/edit-articles"
                            className="dropdown-item"
                            onClick={handleLinkClick}
                          >
                            Redigera artiklar
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/edit-information-segment"
                            className="dropdown-item"
                            onClick={handleLinkClick}
                          >
                            Redigera informationssegment
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/edit-working-hours"
                            className="dropdown-item"
                            onClick={handleLinkClick}
                          >
                            Redigera öppettider
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/edit-videos"
                            className="dropdown-item"
                            onClick={handleLinkClick}
                          >
                            Redigera videor
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/edit-shop"
                            className="dropdown-item"
                            onClick={handleLinkClick}
                          >
                            Redigera butik
                          </Link>
                        </li>
                      </>
                    )}
                  </ul>
                )}
              </li>
            )}

            <li>
              <Link
                to="/treatments"
                className="nav-link"
                onClick={handleLinkClick}
              >
                Behandlingar
              </Link>
            </li>
            <li>
              <Link to="/prices" className="nav-link" onClick={handleLinkClick}>
                Priser
              </Link>
            </li>
            <li>
              <Link
                to="/booking"
                className="nav-link"
                onClick={handleLinkClick}
              >
                Boka
              </Link>
            </li>
            <li>
              <Link
                to="/review?session_id=F85B9F"
                className="nav-link"
                onClick={handleLinkClick}
              >
                Recension
              </Link>
            </li>
            <li>
              <Link
                to="/about-us"
                className="nav-link"
                onClick={handleLinkClick}
              >
                Om oss
              </Link>
            </li>

            <li>
              {isLoggedIn ? (
                <span
                  onClick={() => {
                    handleLogout();
                    handleLinkClick();
                  }}
                  className="nav-link fixed-width-link"
                  style={{ cursor: "pointer" }}
                >
                  Logout
                </span>
              ) : (
                <Link
                  to="/login"
                  className="nav-link fixed-width-link"
                  onClick={handleLinkClick}
                >
                  Login
                </Link>
              )}
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default CustomNavbar;
